import { FileDown, MessageCircle, Archive } from "lucide-react";
import { Link } from "react-router-dom";
import { API } from "@/lib/api";

export default function EPaperButton({ variant = "default" }) {
  const pdfUrl = `${API}/epaper/today`;
  const today = new Date().toLocaleDateString("hi-IN", { day: "numeric", month: "long", year: "numeric" });
  const shareText = `आज का INDIAN-NEWS-21 ई-पेपर (${today}) पढ़ें: `;
  const waUrl = `https://wa.me/?text=${encodeURIComponent(shareText + pdfUrl)}`;

  if (variant === "hero") {
    return (
      <div className="flex flex-wrap gap-3">
        <a href={pdfUrl} target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-[#0F172A] font-bold px-5 py-3 rounded-md shadow-lg text-sm"
          data-testid="epaper-download">
          <FileDown className="w-4 h-4"/> आज का ई-पेपर डाउनलोड करें (PDF)
        </a>
        <a href={waUrl} target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-5 py-3 rounded-md shadow-lg text-sm"
          data-testid="epaper-whatsapp">
          <MessageCircle className="w-4 h-4"/> WhatsApp पर भेजें
        </a>
        <Link to="/epaper" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/30 font-bold px-5 py-3 rounded-md text-sm"
          data-testid="epaper-archive-link">
          <Archive className="w-4 h-4"/> पुराने अंक
        </Link>
      </div>
    );
  }

  return (
    <a href={pdfUrl} target="_blank" rel="noopener noreferrer"
      className="inline-flex items-center gap-1.5 text-xs font-admin uppercase tracking-widest text-amber-700 hover:text-amber-800 border border-amber-400 hover:bg-amber-50 rounded-full px-3 py-1.5"
      data-testid="epaper-link">
      <FileDown className="w-3.5 h-3.5"/> आज का ई-पेपर
    </a>
  );
}
